import { useState, useRef } from "react";
import { ButtonGroup } from "react-bootstrap";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import QuizResultsTable from "./QuizResultsTable";

export default function DownloadPrompt(props) {
  const [fileDownloadUrl, setFileDownloadUrl] = useState(null);

  const doFileDownload = useRef();

  async function downloadResults() {
    let output = "";
    props.answerList.forEach((row) => {
      output += `Číslo otázky: ${row.questionId}\nTestovaná strana: ${row.sideTested}\nVygenerovaný zvuk: ${row.soundName}\nPočet pokusov: ${row.attemptsCount}\nOdpoveď 1: ${row.answer1}\nOdpoveď 2: ${row.answer2}\nKonečná odpoveď: ${row.finalAnswer}\n__________________\n`;
    });
    const blob = new Blob([output]);
    const fileDownloadUrl = URL.createObjectURL(blob);
    await setFileDownloadUrl(fileDownloadUrl);
    doFileDownload.current.click();
    URL.revokeObjectURL(fileDownloadUrl);
    setFileDownloadUrl("");
  }
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={props.viewDownload}
    >
      <ButtonGroup
        id="ButtonGroup"
        variant="contained"
        className="selection-group"
        aria-label="outlined primary button group"
        style={{ display: "none" }}
      >
        <div className="quiz-text" id="results-title">
          Výsledky testu
        </div>
        <QuizResultsTable table={props.answerList} />
        <div className="quiz-text">Prajete si stiahnúť výsledky?</div>
        <Button
          variant="contained"
          className="selection-button"
          onClick={async () => {
            await downloadResults();
            props.resetTest();
            props.historyPush("/");
          }}
        >
          Áno
        </Button>
        <Button
          variant="contained"
          className="selection-button"
          id="selection-button-red"
          onClick={() => {
            props.resetTest();
            props.historyPush("/");
          }}
        >
          Nie
        </Button>
      </ButtonGroup>
      <a
        style={{ display: "none" }}
        download={"vysledky.txt"}
        href={fileDownloadUrl}
        ref={doFileDownload}
      >
        Download
      </a>
    </Backdrop>
  );
}
